import { makeVar } from '@apollo/client';
import { authUtil } from 'modules/common/layer00';



export const isLoggedInVar = makeVar(authUtil.evaluateInitialIsLoggedIn());
export const isLoggedInUserSuperAdmin = makeVar<'yes' | 'no' | 'notAttempted'>('notAttempted');
export const showLoadingOverlay = makeVar<boolean>(false);
